import { Button, Glyphicon, Modal } from 'react-bootstrap'
import {
  downloadFramesByAverageIdList,
  getSaxsDensityPlot,
  getSaxsGuinierPlot,
  getSaxsKratkyPlot,
  getSaxsScatteringPlot,
  getZip,
} from '../../../api/ispyb.js'
import { getExponentialNotation, getRoundedNumber } from './DataCollectionHelper'

import ImageZoom from 'react-medium-image-zoom'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * React component used to render datasets of an experiment
 */
class DataCollectionListSummaryTableRow extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isModalVisible: false,
    }

    this.toggleModal = this.toggleModal.bind(this)
  }

  render() {
    const getPorodMWEstimation = subtraction_volume => {
      if (subtraction_volume) {
        try {
          return (
            Number(subtraction_volume / 2).toFixed(1) +
            String.fromCharCode(160) +
            '-' +
            String.fromCharCode(160) +
            Number(subtraction_volume / 1.5).toFixed(1)
          )
        } catch (e) {
          return subtraction_volume
        }
      }
    }

    const { dataCollection } = this.props
    if (dataCollection.experimentType === 'HPLC') {
      return null
    }

    return (
      <tr style={this.props.rowStyle ? this.props.rowStyle : null}>
        <td>
          <span
            style={{
              margin: '5px',
              padding: '5px',
              borderRadius: '5px',
              color: 'white',
              backgroundColor: dataCollection.macromoleculeId ? '#207a7a' : 'gray',
            }}
          >
            #
          </span>

          {dataCollection.macromoleculeId && (
            <div style={{ marginTop: '10px' }}>
              <div style={{ width: '175px', textAlign: 'left' }}>
                columnName : <b>{dataCollection.measurementCode && dataCollection.measurementCode.columnName}</b>
              </div>
              <div style={{ width: '175px', textAlign: 'left' }}>
                columnVolume (mL):
                <b>{dataCollection.measurementCode && dataCollection.measurementCode.columnVolume}</b>
              </div>
              <div style={{ width: '175px', textAlign: 'left' }}>
                elutionFlux (mL/min):
                <b>{dataCollection.measurementCode && dataCollection.measurementCode.elutionFlux} </b>
              </div>
            </div>
          )}
        </td>

        <td>
          {dataCollection.macromoleculeId ? (
            <div>
              <b>{dataCollection.macromoleculeAcronym} </b>
              <br />
              {dataCollection.specimenConcentration}
              <span style={{ fontSize: '9px', color: 'gray', paddingLeft: '3px' }}>mg/ml</span>
              <br />
              {dataCollection.run_exposureTemperature}&nbsp;&#8451;
              <br />
              {dataCollection.measurementVolumeToLoad} &#181;l
              <br />
              <Link to={getZip(this.props.user, this.props.proposal, this.props.dataCollection.subtractionId)}>
                <Glyphicon glyph="download"> </Glyphicon>
              </Link>
              <Link to="#" onClick={() => this.toggleModal(true)}>
                <Glyphicon glyph="folder-close"> </Glyphicon>
                <Modal show={this.state.isModalVisible}>
                  <Modal.Header>
                    <Modal.Title style={{ textAlign: 'center' }}> Average file path </Modal.Title>
                    <Modal.Body> {this.props.dataCollection.subtraction_sampleAverageFilePath} </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={e => {
                          e.stopPropagation()
                          this.toggleModal(false)
                        }}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal.Header>
                </Modal>
              </Link>
            </div>
          ) : (
            <div>{dataCollection.bufferAcronym}</div>
          )}
        </td>

        <td>
          <FrameLabel
            run_mergedFrameCount={dataCollection.run_mergedFrameCount}
            run_totalFrameCount={dataCollection.run_totalFrameCount}
          />
          <a
            href={downloadFramesByAverageIdList(
              this.props.user,
              this.props.proposal,
              this.props.dataCollection.merge_id
            )}
          >
            <Glyphicon glyph="download" />
          </a>
        </td>

        <EmptyColBasedOnIfProp ifProp={dataCollection.macromoleculeId}>
          <NAContentBasedOnIfProp ifProp={dataCollection.guinierAnalysis_rg}>
            <span>
              {getRoundedNumber(dataCollection.guinierAnalysis_rg, 3)}
              <span style={{ fontSize: '10px', color: 'gray' }}>nm</span>
            </span>
          </NAContentBasedOnIfProp>
        </EmptyColBasedOnIfProp>

        <EmptyColBasedOnIfProp ifProp={dataCollection.macromoleculeId}>
          <NAContentBasedOnIfProp ifProp={dataCollection.guinierAnalysis_rg}>
            <span>
              {dataCollection.guinierAnalysis_firstPointUsed} - {dataCollection.guinierAnalysis_lastPointUsed} (
              {dataCollection.guinierAnalysis_lastPointUsed - dataCollection.guinierAnalysis_firstPointUsed})
            </span>
          </NAContentBasedOnIfProp>
        </EmptyColBasedOnIfProp>

        <EmptyColBasedOnIfProp ifProp={dataCollection.macromoleculeId}>
          <NAContentBasedOnIfProp ifProp={dataCollection.guinierAnalysis_I0}>
            <span>
              {getRoundedNumber(dataCollection.guinierAnalysis_I0, 1)} &#177;
              {getExponentialNotation(dataCollection.guinierAnalysis_I0StdDev, 3)}
            </span>
          </NAContentBasedOnIfProp>
        </EmptyColBasedOnIfProp>

        <EmptyColBasedOnIfProp ifProp={dataCollection.macromoleculeId}>
          <NAContentBasedOnIfProp ifProp={dataCollection.gnomAnalysis_rg}>
            <span>
              {getRoundedNumber(dataCollection.gnomAnalysis_rg, 3)}
              <span style={{ fontSize: '10px', color: 'gray' }}>nm</span>
            </span>
          </NAContentBasedOnIfProp>
        </EmptyColBasedOnIfProp>

        <EmptyColBasedOnIfProp ifProp={dataCollection.macromoleculeId}>
          <NAContentBasedOnIfProp ifProp={dataCollection.gnomAnalysis_total}>
            <span>{getRoundedNumber(dataCollection.gnomAnalysis_total, 3)}</span>
          </NAContentBasedOnIfProp>
        </EmptyColBasedOnIfProp>

        <EmptyColBasedOnIfProp ifProp={dataCollection.macromoleculeId}>
          <NAContentBasedOnIfProp ifProp={dataCollection.gnomAnalysis_dmax}>
            <span>
              {getRoundedNumber(dataCollection.gnomAnalysis_dmax, 3)}
              <span style={{ fontSize: '10px', color: 'gray' }}>nm</span>
            </span>
          </NAContentBasedOnIfProp>
        </EmptyColBasedOnIfProp>

        <EmptyColBasedOnIfProp ifProp={dataCollection.macromoleculeId}>
          <NAContentBasedOnIfProp ifProp={dataCollection.porodAnalysis_volume}>
            <span>
              {getRoundedNumber(dataCollection.porodAnalysis_volume, 3)}
              <span style={{ fontSize: '10px', color: 'gray' }}>
                nm<sup>3</sup>
              </span>
            </span>
          </NAContentBasedOnIfProp>
        </EmptyColBasedOnIfProp>

        <EmptyColBasedOnIfProp ifProp={dataCollection.macromoleculeId}>
          <NAContentBasedOnIfProp ifProp={dataCollection.porodAnalysis_volume}>
            <span>
              {getPorodMWEstimation(dataCollection.porodAnalysis_volume)}
              <span style={{ fontSize: '10px', color: 'gray' }}> kD</span>
            </span>
          </NAContentBasedOnIfProp>
        </EmptyColBasedOnIfProp>

        {dataCollection.rowSpan ? (
          <td rowSpan={dataCollection.rowSpan} style={{ borderBottom: '2px solid #3892d3' }}>
            <div style={{ minWidth: '100px', maxWidth: '250px', margin: 'auto' }}>
              <ImageZoom
                image={{
                  src:
                    dataCollection.subtractionId &&
                    getSaxsScatteringPlot(this.props.user, this.props.proposal, dataCollection.subtractionId),
                  alt: 'Scattering plot',
                  className: 'img',
                  style: { display: 'block', maxWidth: '100%', height: 'auto' },
                }}
                zoomImage={{
                  src:
                    dataCollection.subtractionId &&
                    getSaxsScatteringPlot(this.props.user, this.props.proposal, dataCollection.subtractionId),
                  alt: 'Scattering plot',
                }}
              />
            </div>
          </td>
        ) : null}

        {dataCollection.rowSpan ? (
          <td rowSpan={dataCollection.rowSpan} style={{ borderBottom: '2px solid #3892d3' }}>
            <div style={{ minWidth: '100px', maxWidth: '250px', margin: 'auto' }}>
              <ImageZoom
                image={{
                  src: getSaxsKratkyPlot(this.props.user, this.props.proposal, dataCollection.subtractionId),
                  alt: 'Krakty plot',
                  className: 'img',
                  style: { display: 'block', maxWidth: '100%', height: 'auto' },
                }}
                zoomImage={{
                  src: getSaxsKratkyPlot(this.props.user, this.props.proposal, dataCollection.subtractionId),
                  alt: 'Krakty plot',
                }}
              />
            </div>
          </td>
        ) : null}

        {dataCollection.rowSpan ? (
          <td rowSpan={dataCollection.rowSpan} style={{ borderBottom: '2px solid #3892d3' }}>
            <div style={{ minWidth: '100px', maxWidth: '250px', margin: 'auto' }}>
              <ImageZoom
                image={{
                  src: getSaxsDensityPlot(this.props.user, this.props.proposal, dataCollection.subtractionId),
                  alt: 'Density plot',
                  className: 'img',
                  style: { display: 'block', maxWidth: '100%', height: 'auto' },
                }}
                zoomImage={{
                  src: getSaxsDensityPlot(this.props.user, this.props.proposal, dataCollection.subtractionId),
                  alt: 'Density plot',
                }}
              />
            </div>
          </td>
        ) : null}

        {dataCollection.rowSpan ? (
          <td rowSpan={dataCollection.rowSpan} style={{ borderBottom: '2px solid #3892d3' }}>
            <div style={{ minWidth: '100px', maxWidth: '250px', margin: 'auto' }}>
              <ImageZoom
                image={{
                  src: getSaxsGuinierPlot(this.props.user, this.props.proposal, dataCollection.subtractionId),
                  alt: 'Guinier plot',
                  className: 'img',
                  style: { display: 'block', maxWidth: '100%', height: 'auto' },
                }}
                zoomImage={{
                  src: getSaxsGuinierPlot(this.props.user, this.props.proposal, dataCollection.subtractionId),
                  alt: 'Guinier plot',
                }}
              />
            </div>
          </td>
        ) : null}

        {dataCollection.rowSpan ? (
          <td rowSpan={dataCollection.rowSpan} style={{ borderBottom: '2px solid #3892d3' }}>
            <div style={{ paddingBottom: '5px' }}>
              <Link
                to={
                  '/sessions/saxs/proposal/' +
                  this.props.proposal +
                  '/session/' +
                  this.props.sessionId +
                  '/experiments/' +
                  this.props.experimentId +
                  '/dataCollection/' +
                  this.props.dataCollection.dataCollectionId +
                  '/reduction'
                }
                target="_blank"
              >
                <Button bsStyle="primary" bsSize="xsmall" block disabled={!dataCollection.runId}>
                  Data reduction
                </Button>
              </Link>
            </div>
            <div style={{ paddingBottom: '5px' }}>
              <Link
                to={
                  '/sessions/saxs/proposal/' +
                  this.props.proposal +
                  '/session/' +
                  this.props.sessionId +
                  '/experiments/' +
                  this.props.experimentId +
                  '/dataCollection/' +
                  this.props.dataCollection.dataCollectionId +
                  '/abinitio'
                }
                target="_blank"
              >
                <Button bsStyle="primary" bsSize="xsmall" block disabled={!dataCollection.subtraction_abInitioId}>
                  Ab initio
                </Button>
              </Link>
            </div>
            <div style={{ paddingBottom: '5px' }}>
              <Link to="#">
                <Button bsStyle="primary" bsSize="xsmall" block disabled={!dataCollection.fit}>
                  Fit
                </Button>
              </Link>
            </div>
            <div style={{ paddingBottom: '5px' }}>
              <Link to="#">
                <Button bsStyle="primary" bsSize="xsmall" block disabled={!dataCollection.superposition}>
                  Superposition
                </Button>
              </Link>
            </div>
            <div style={{ paddingBottom: '5px' }}>
              <Link to="#">
                <Button bsStyle="primary" bsSize="xsmall" block disabled={!dataCollection.rigidBody}>
                  Rigid body
                </Button>
              </Link>
            </div>
          </td>
        ) : null}
      </tr>
    )
  }

  /**
   * Toggle Modal visibility
   * @param {boolean} isModalVisible whether the modal should become visible or not
   */
  toggleModal(isModalVisible) {
    this.setState({ isModalVisible: isModalVisible })
  }
}

/** Render an empty table column if ifprop is not set. */
const EmptyColBasedOnIfProp = props => {
  if (props.ifProp) {
    return <td> {props.children} </td>
  }
  return <td />
}

const NAContentBasedOnIfProp = props => {
  if (props.ifProp) {
    return props.children
  }
  return <span className="notavailablefield"> NA </span>
}

const FrameLabel = props => {
  const merge = props.run_mergedFrameCount
  const total = props.run_totalFrameCount
  let color

  if (!merge || !total) {
    color = 'orange'
  } else {
    if (merge / total < 0.3) {
      color = 'red'
    }
    if (merge / total >= 0.3 && merge / total < 0.7) {
      color = 'orange'
    }
  }

  return (
    <div style={{ backgroundColor: color }}>
      {merge || 'NA'} / {total || 'NA'}
    </div>
  )
}

DataCollectionListSummaryTableRow.propTypes = {
  /** Datacollection */
  dataCollection: PropTypes.object,
  /** experiment identifier */
  experimentId: PropTypes.number,
  /** experiment type */
  experimentType: PropTypes.oneOf(['HPLC']),
  /** ESRF session identifier */
  sessionId: PropTypes.string,
  /** User */
  user: PropTypes.object,
}

export default DataCollectionListSummaryTableRow
